import React, {useEffect, useState} from 'react';
import { createRoot } from 'react-dom/client';

import VerticalBarChart from '../charts/VerticalBarChart';

import {formatRace} from '../../common';

const TopRaces = () => {

  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get('/api/welcome/top-races')
         .then(response => {
            //console.log('response', response)
            setData(response.data);
          })
          .catch(error => {
            console.log('error', error)
          });
  }, []);

  if (! data)
  {
    return null;
  }

  return (
    <VerticalBarChart
      data={data.map(item => (
        {
          name: formatRace(item.race),
          Support: item.S,
          Oppose: item.O
        }
      ))}
      columns={{
        oppose: 'Oppose',
        support: 'Support'
      }}
      labelWidth={150}
    />
  );
};

if (document.getElementById('top-races')) {
  const root = createRoot(document.getElementById('top-races'));
  root.render(<TopRaces />);
}
